import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel';
import Sub_header from '../Sub_header';

const Assign_service = () => {
  const { carrier_id, product_id } = useParams();

  const [countries, setCountries] = useState([]);
  const [services, setServices] = useState([]);
  const [serviceSelections, setServiceSelections] = useState({});
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  


const toggleSidebar = () => {
  setIsSidebarOpen(!isSidebarOpen);
  const homeSection = document.querySelector('.home-section');
  if (homeSection) {
      homeSection.classList.toggle('sidebar-closed');
  }
};

  useEffect(() => {
    fetchCountries();
    fetchServices();
    fetchAssignedServices();
  }, []);

  // ✅ Fetch all countries
  const fetchCountries = async () => {
    let res = await axios.post(
      `${exportValue.host}/${exportValue.version}/${exportValue.api}/international_zone_country_list`,
      {},
      { headers: exportValue.headers }
    );

    if (res.data.status) {
      setCountries(res.data.output);
    }
  };

  // ✅ Fetch services (product types)
  const fetchServices = async () => {
    let res = await axios.post(
      `${exportValue.host}/${exportValue.version}/${exportValue.api}/product_type`,
      { carrier_id },
      { headers: exportValue.headers }
    );

    if (res.data.status) {
      setServices(res.data.output);
    }
  };

  // ✅ Prefill existing mapping
  const fetchAssignedServices = async () => {
    let res = await axios.post(
      `${exportValue.host}/${exportValue.version}/${exportValue.api}/getAssignedServices`,
      { carrier_id, product_id },
      { headers: exportValue.headers }
    );

    if (res.data.status) {
      let map = {};
      res.data.output.forEach(item => {
        map[item.country_id] = item.service_code;
      });
      setServiceSelections(map);
    }
  };

  // ✅ Handle dropdown change
  const handleServiceChange = (country_id, value) => {
    setServiceSelections(prev => ({
      ...prev,
      [country_id]: value
    }));
  };

  // ✅ Save API
  const handleSave = async () => {
    try {
      let payload = Object.entries(serviceSelections).map(
        ([country_id, service_code]) => ({
          carrier_id: Number(carrier_id),
          product_id: Number(product_id),
          country_id: Number(country_id),
          service_code
        })
      );

      let res = await axios.post(
        `${exportValue.host}/${exportValue.version}/${exportValue.api}/assignServiceToCountry`,
        { data: payload },
        { headers: exportValue.headers }
      );

      if (res.data.status) {
        Swal.fire("Success", "Services saved successfully", "success");
      } else {
        Swal.fire("Error", "Something went wrong", "error");
      }
    } catch (err) {
      Swal.fire("Error", "API failed", "error");
    }
  };

  return (
    <div>
          <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
       
       <section class="home-section">
               {/* <?php
               include('sub_header.php');
               ?> 
            */}
       <Sub_header/>
       <section>
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div class="d-block mb-4 mb-md-0">
                <div class="back_btn_wrap">
                            <a href="/product" class="back_btn">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="corner-up-left" class="lucide lucide-corner-up-left"><polyline points="9 14 4 9 9 4"></polyline><path d="M20 20v-7a4 4 0 0 0-4-4H4"></path></svg>
                            </a>
                           
                        </div>
 <h4>Assign Service to Country</h4>
                  
                </div>
         <div><a href={`/international_product_details/${product_id}/${carrier_id}`} className="btn btn-primary">Set Pricing</a></div>       
              
            </div>
            
    </section>
    
    <div className="container mt-4 mb-4">
     

      <table className="table table-bordered mt-3">
        <thead>
          <tr>
            <th>Country</th>
            <th>Service</th>
          </tr>
        </thead>
        <tbody>
          {countries.map(country => (
            <tr key={country.country_id}>
              <td>{country.country_name}</td>
              <td>
                <select
                  className="form-control"
                  value={serviceSelections[country.country_id] || ""}
                  onChange={(e) =>
                    handleServiceChange(country.country_id, e.target.value)
                  }
                >
                  <option value="">Select</option>

                  {services.map(s => (
                    <option key={s.product_type_name} value={s.product_type_name}>
                      {s.product_type_name}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button className="btn btn-primary mb-4" onClick={handleSave}>
        Save
      </button>
    </div>
    </section>
    </div>
  );
};

export default Assign_service;